<template>

    <b-form-group id="input-group-6" label="Paramètres:" label-cols-sm="4" label-for="input-6">
      <b-form-input id="input-6" style="width:150px" v-model="param.valeur" readonly="readonly"></b-form-input>
    </b-form-group>

</template>

<script>

import {ref} from "vue";

export default {
    name: 'ParametreItem',
    props: {
        parametre:{
            required:true,
            type: Object
        },
    },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(props) {
    const param = ref(props.parametre);

    return {
      param
    }
  }
}
</script>

<style>
.card-body{
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
</style>